var FcDeadlineContractOutlinedSelectModule = /** @class */ (function () {
    function FcDeadlineContractOutlinedSelectModule() {
    }
    return FcDeadlineContractOutlinedSelectModule;
}());
export { FcDeadlineContractOutlinedSelectModule };
